import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileZipper,
  faBoxArchive,
} from '@fortawesome/free-solid-svg-icons';
import './DataColumns.scss';

/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  downloadRolloutArchive,
  showBugs,
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
}) => {
  const dataColumns = [
    {
      field: 'rn',
      title: 'RN',
      editable: false,
      show: false,
      minResizableWidth: 150,
      filterable: true,
      className: 'grid-cells',
    },
    {
      field: 'rollout_name',
      title: 'Rollout Name',
      editable: false,
      show: true,
      width: '350px',
      minResizableWidth: 250,
      filterable: true,
      className: 'grid-cells',
      cell: (props) => (
        <td className="rollouts-name">
          <>
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                downloadRolloutArchive('w', props.dataItem.rollout_name, false);
              }}
            >
              {props.dataItem.rollout_name}
            </Link>
          </>
        </td>
      ),
    },
    {
      field: 'rollout_description',
      title: 'Description',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      filterable: true,
      className: 'grid-cells',
    },
    {
      field: 'created_date',
      title: 'Date',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      filterable: true,
      className: 'grid-cells',
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'created_date',
        }),
      cell: GridDateCell,
    },
    {
      field: 'total_bugs',
      title: '# of Bugs',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      filterable: false,
      cell: (props) => (
        <td className="link-column">
          <>
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                showBugs(props.dataItem.rollout_name);
              }}
            >
              {props.dataItem.total_bugs}
            </Link>
          </>
        </td>
      ),
    },
    {
      field: 'download',
      title: 'Download',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      filterable: false,
      cell: (props) => (
        <td className="rollouts-action">
          <>
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                downloadRolloutArchive('w', props.dataItem.rollout_name, false);
              }}
            >
              <FontAwesomeIcon icon={faFileZipper} title="ZIP" />
            </Link>
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                downloadRolloutArchive('l', props.dataItem.rollout_name, false);
              }}
            >
              <FontAwesomeIcon icon={faBoxArchive} title="TAR" />
            </Link>
          </>
        </td>
      ),
    },
  ];

  return dataColumns;
};
export default DataColumns;
